import {
    InquiryStatusChange,
    inquiryStatusChangeDecoder
} from './InquiryStatusChange'
import {BpsUser, bpsUserDecoder} from './BpsUser'
import {Decoder, field, nullable, object} from 'json-bouncer'
import {Cis2User, cis2UserDecoder} from './Cis2User'

export interface InquiryStatusChangeWithUsers {
    readonly inquiryStatusChange: InquiryStatusChange
    readonly bpsUser: BpsUser | null
    readonly cis2User: Cis2User | null
}

export function inquiryStatusChangeWithUsersDecoder(): Decoder<InquiryStatusChangeWithUsers> {
    return object({
        inquiryStatusChange: field('inquiryStatusChange', inquiryStatusChangeDecoder()),
        bpsUser: field('bpsUser', nullable(bpsUserDecoder())),
        cis2User: field('cis2User', nullable(cis2UserDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryStatusChangeWithUsers.ts